import React, { useEffect, useState } from 'react';
import { helpService } from '../services/helpService';
import { renderMarkdown } from '../utils/markdownUtils';
import './HelpModal.css';

/**
 * HelpModal Component
 * 
 * Displays context-aware help guides rendered from Markdown.
 */
const HelpModal = () => {
    const [helpState, setHelpState] = useState(helpService.getState());

    useEffect(() => {
        const unsubscribe = helpService.subscribe(setHelpState);
        return unsubscribe;
    }, []);

    if (!helpState.isOpen) return null;

    const handleClose = () => {
        helpService.closeHelp();
    };

    return (
        <div className="help-modal-overlay" onClick={handleClose}>
            <div className="help-modal-content" onClick={e => e.stopPropagation()}>
                <header className="help-modal-header">
                    <div className="help-header-title">
                        <span className="help-icon">💡</span>
                        <h2>Trip Planner Guide</h2>
                    </div>
                    <button className="close-button" onClick={handleClose}>&times;</button>
                </header>

                <div className="help-modal-body">
                    {helpState.isLoading ? (
                        <div className="help-loading">
                            <span className="spinner"></span>
                            <p>Fetching guide...</p>
                        </div>
                    ) : helpState.error ? (
                        <div className="help-error">
                            <p>⚠️ Error: {helpState.error}</p>
                            <button onClick={() => helpService.openHelp(helpState.context)}>Retry</button>
                        </div>
                    ) : (
                        <div className="markdown-render">
                            {renderMarkdown(helpState.content)}
                        </div>
                    )}
                </div>

                <footer className="help-modal-footer">
                    <button className="secondary-button" onClick={() => helpService.openHelp('CAP-000-Getting-Started')}>
                        Help Home
                    </button>
                    <button className="primary-button" onClick={handleClose}>
                        Got it!
                    </button>
                </footer>
            </div>
        </div>
    )
};

export default HelpModal;
